import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import unregister from './registerServiceWorker'

// adjust font sizes for high pixel density screens
let scale, testVal = window.innerHeight < document.body.clientWidth ? window.innerHeight : document.body.clientWidth;
if (testVal > 4000) scale = 2
else if (testVal > 3000) scale = 1
else scale = 0;
document.getElementsByTagName('html')[0].style.fontSize =
scale === 2 ? '82.5%'
: scale === 1 ? '72.5%'
: '62.5%';

unregister();
ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
